module.exports = __webpack_public_path__ + "static/media/logo-white.01c5ee10.png";